import BaseDirective from '@primevue/core/basedirective';
import StyleClassStyle from 'primevue/styleclass/style';

const BaseStyleClass = BaseDirective.extend({
    style: StyleClassStyle
});

export default BaseStyleClass;
